import React, { useCallback, useEffect, useState } from 'react';

import { ErrorDialog } from '../components/ErrorDialog';
import { subscribeApiErrorDialog } from '../services/apiErrorDialog';

interface ApiErrorDialogState {
  open: boolean;
  message: string;
}

const ApiErrorDialogProvider: React.FC = ({ children }) => {
  const [dialogState, setDialogState] = useState<ApiErrorDialogState>({
    open: false,
    message: '',
  });

  useEffect(() => {
    return subscribeApiErrorDialog((message) => {
      setDialogState({
        open: true,
        message,
      });
    });
  }, []);

  const handleClose = useCallback(() => {
    setDialogState((state) => ({
      ...state,
      open: false,
    }));
  }, []);

  return (
    <>
      {children}

      <ErrorDialog
        open={dialogState.open}
        message={dialogState.message}
        onClose={handleClose}
      />
    </>
  );
};

export { ApiErrorDialogProvider };
